import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
// import { gsapBreakpoints } from '../utility/breakpoints'

// Handling all animations & scroll interactions with blocks here

const infogramBlock = {
  el: {
    // bottomNavigation: document.querySelector<HTMLElement>('.bottom-navigation'),
    // bottomNavigationButtons: document.querySelectorAll<HTMLElement>('.bottom-navigation .button'),
    // footerContainer: document.querySelector<HTMLElement>('.body .footer > .container'),
    // imageBlocks: document.querySelectorAll<HTMLElement>('.image-block'),
    infogramBlocks: document.querySelectorAll<HTMLElement>('.infogram-block'),
    // managementBlocks: document.querySelectorAll<HTMLElement>('.management-block'),
    // numbersBlocks: document.querySelectorAll<HTMLElement>('.numbers-block'),
    // sectionHeadlineContainers: document.querySelectorAll<HTMLElement>('.main__section-headline-container'),
    // textBlocks: document.querySelectorAll<HTMLElement>('.text-block'),
  },

  init(): void {
    gsap.registerPlugin(ScrollTrigger)

    this.el.infogramBlocks.forEach((block) => {
      this.handleInfogramBlockReveal(block)
    })
  },

  handleInfogramBlockReveal(item): void {
    const headlineContainer = item.querySelector('.infogram-block__headline-container')
    const embedContainer = item.querySelector('.infogram-block__embed-container')

    const scriptElement = document.createElement('script')
    const embedElement = item.querySelector('.infogram-block__embed-content')
    const embedCode = embedElement.dataset.embed
    const idMatch = embedCode.match(/id="([^"]+)"/)
    const srcMatch = embedCode.match(/src="([^"]+)"/)

    scriptElement.id = idMatch[1]
    scriptElement.src = srcMatch[1]
    scriptElement.type = 'text/javascript'

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            embedElement.appendChild(scriptElement)

            const interval = setInterval(() => {
              const iframe = embedElement.parentElement.querySelector('iframe')

              if (iframe) {
                clearInterval(interval)

                if (headlineContainer) {
                  this.handleItemReveal(headlineContainer)
                }

                if (embedContainer) {
                  this.handleItemReveal(embedContainer)
                }

                setTimeout(() => {
                  ScrollTrigger.getAll().forEach((trigger) => {
                    trigger.refresh()
                  })
                }, 123)
              }
            }, 33)

            observer.unobserve(embedContainer)
          }
        })
      },
      {
        root: null,
        rootMargin: '0px', // `${window.innerHeight / 2}px`,
        threshold: 0,
      }
    )

    observer.observe(embedContainer)
  },

  handleItemReveal(item): void {
    if (item.querySelector('[data-reveal-in]')) {
      gsap.fromTo(
        item.querySelector('[data-reveal-in]'),
        {
          opacity: 0,
          y: 66,
        },
        {
          ease: 'none',
          opacity: 1,
          // overwrite: true,
          scrollTrigger: {
            end: '+=15%',
            scrub: 1,
            start: '0% 90%',
            trigger: item,
          },
          y: 0,
        }
      )
    }

    if (item.querySelector('[data-reveal-out]')) {
      gsap.fromTo(
        item.querySelector('[data-reveal-out]'),
        {
          opacity: 1,
          y: 0,
        },
        {
          ease: 'none',
          opacity: 0,
          // overwrite: true,
          scrollTrigger: {
            end: '+=15%',
            scrub: 1,
            start: '100% 15%',
            trigger: item,
          },
          y: -66,
        }
      )
    }
  },
}

export default infogramBlock
